import { Text } from "@mantine/core";
import { useParams } from "react-router-dom";
import { PageHeader } from "../../../components/PageHeader";
import { CustomFieldValuesPanel } from "./CustomFieldValuesPanel";

interface CustomFieldValuesPageProps {
  objectType: string;
  paramName: string;
}

export const CustomFieldValuesPage = ({
  objectType,
  paramName,
}: CustomFieldValuesPageProps) => {
  const params = useParams();
  const objectId = params[paramName];

  if (!objectId) {
    return (
      <div className="wp-fade-in">
        <PageHeader title="Custom Field Values" showBreadcrumbs={false} />
        <Text c="red">Missing route parameter: {paramName}</Text>
      </div>
    );
  }

  return (
    <div className="wp-fade-in">
      <PageHeader
        title="Custom Field Values"
        subtitle="View and edit custom field values for this entity"
        showBreadcrumbs={false}
      />
      <CustomFieldValuesPanel objectType={objectType} objectId={objectId} />
    </div>
  );
};
